module.exports = __webpack_public_path__ + "img/4dcd78e.jpg";